import { render, staticRenderFns } from "./DocumentExchangeRatePanel.vue?vue&type=template&id=640de497"
import script from "./DocumentExchangeRatePanel.vue?vue&type=script&lang=js"
export * from "./DocumentExchangeRatePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports